import React, { forwardRef } from "react";
import {
  HelperText,
  IconStyles,
  InputWrapper,
  Label,
  StyledInput,
  Wrapper
} from "components/Input/styled";

const Input = forwardRef(
  (
    {
      id,
      type = "text",
      label,
      helperText,
      size = "M",
      disabled,
      value,
      onChange,
      placeholder,
      leftIcon,
      rightIcon,
      required = false,
      autoComplete = "off",
      className,
      handleClearSearch,
      leftClass,
      readOnly,
      inputWrapperClass,
      countryCodePlaceholder,
      countryCode,
      codeId,
      onCountryCodeChange,
      country_code_value,
      hasError,
      onClick,
      inputProps = {},
      countryCodeOnlyDisabled = false,
      onFocus,
      multipleFilter,
      styledInput,
      onKeyDown
    },
    ref
  ) => {
    const showRightIcon =
      type !== "number" && !!rightIcon && (value || readOnly);

    const handleNumberChange = (e) => {
      const val = e.target.value;

      if (type === "tel" || label === "Phone") {
        // Phone number: max 10 digits
        if (val === "" || (Number(val) >= 0 && val.length <= 10)) {
          onChange?.(e);
        }
      } else {
        // Regular number: max 10 billion
        if (val === "" || (Number(val) >= 0 && Number(val) <= 1000000000)) {
          onChange?.(e);
        }
      }
    };

    return (
      <Wrapper size={size} className={className}>
        {label && (
          <Label htmlFor={id} size={size}>
            {label}
            {required && <span>*</span>}
          </Label>
        )}

        {/* Wrap only for phone type */}
        {type === "tel" ? (
          <div className="country-code-wrapper">
            {/* Country Code Input */}
            <InputWrapper
              size={size}
              disabled={countryCodeOnlyDisabled || disabled}
              className="phone-wrapper"
            >
              <StyledInput
                id={codeId}
                ref={ref}
                type={type}
                name={codeId}
                value={country_code_value || ""}
                onChange={onCountryCodeChange}
                placeholder={countryCodePlaceholder || "+91"}
                disabled={countryCodeOnlyDisabled || disabled}
                size={size}
                autoComplete={autoComplete}
                readOnly={readOnly}
                onClick={onClick}
                {...inputProps}
                onFocus={onFocus}
              />
            </InputWrapper>

            {/* Phone Number Input */}
            <InputWrapper
              size={size}
              disabled={disabled}
              hasError={hasError}
              className={`phone-wrapper-styles ${
                inputWrapperClass ? inputWrapperClass : ""
              }`}
            >
              <StyledInput
                id={id}
                ref={ref}
                type="tel"
                name={id}
                value={value || ""}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                size={size}
                autoComplete={autoComplete}
                readOnly={readOnly}
                onClick={onClick}
                {...inputProps}
                onFocus={onFocus}
              />
            </InputWrapper>
          </div>
        ) : (
          // Normal input for other types
          <InputWrapper
            size={size}
            disabled={disabled}
            hasError={hasError}
            className={`${type === "search" ? "search-input" : ""} ${
              inputWrapperClass ? inputWrapperClass : ""
            } ${multipleFilter}`}
          >
            {leftIcon && (
              <IconStyles
                size={size}
                className={`left-icon ${leftClass || ""}`}
              >
                {leftIcon}
              </IconStyles>
            )}

            <StyledInput
              id={id}
              ref={ref}
              type={type}
              name={id}
              value={value || ""}
              onChange={type === "number" ? handleNumberChange : onChange}
              placeholder={placeholder}
              disabled={disabled}
              size={size}
              autoComplete={autoComplete}
              min={type === "number" ? 0 : undefined}
              max={type === "number" ? 1000000000 : undefined}
              readOnly={readOnly}
              onClick={onClick}
              onKeyDown={onKeyDown}
              {...inputProps}
              onFocus={onFocus}
              className={styledInput}
            />

            {showRightIcon && (
              <IconStyles
                size={size}
                className="right-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  if (handleClearSearch) handleClearSearch();
                }}
              >
                {rightIcon}
              </IconStyles>
            )}
          </InputWrapper>
        )}

        {helperText && (
          <HelperText size={size} hasError>
            {helperText}
          </HelperText>
        )}
      </Wrapper>
    );
  }
);

Input.displayName = "Input";

export default Input;
